export const BLOCKED_EMAIL_DOMAINS = [
	"mailinator.com",
	"guerrillamail.com",
	"temp-mail.org",
	"10minutemail.com",
	"yopmail.com",
	"throwawaymail.com",
	"fakeinbox.com",
	"getnada.com",
	"sharklasers.com",
	"maildrop.cc",
	"dispostable.com",
	"moakt.com",
	"mytemp.email",
	"tempmailaddress.com",
	"emailondeck.com",
	"spamgourmet.com",
	"tmail.ws",
	"anonbox.net",
	"mailsac.com",
	"dropmail.me",
	"burnermail.io",
	"mailnesia.com",
	"instant-email.org",
	"tempail.com",
	"emailtemporal.org",
	"luxusmail.org",
	"airmail.cc",
	"spamavert.com",
	"fakemailgenerator.com",
	"inboxbear.com",
	"easytrashmail.com",
	"discard.email",
	"tempmailo.com",
	"mohmal.com",
	"zmail.ru",
	"mail-temp.com",
	"boun.cr",
	"binkmail.com",
	"trbvm.com",
	"spamfree24.org",
	"trashmail.com",
	"somemail.com",
	"email.com",
	"dummy.com",
];
